/*
 * Inicializa o carrossel (Slick) para o Loop de Consulta
 * na home page (apenas em mobile).
 */
jQuery(document).ready(function($) {

    function initHomeMobileCarousel() {
        var $carouselTarget = $('.js-mobile-carousel ul.wp-block-post-template');

        if (!$carouselTarget.length) {
            return;
        }

        if ($(window).width() < 768) {
            if (!$carouselTarget.hasClass('slick-initialized')) {
                $carouselTarget.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    infinite: false,
					centerMode: true,
					centerPadding: '40px',
                });
            }
        } else {
            if ($carouselTarget.hasClass('slick-initialized')) {
                $carouselTarget.slick('unslick');
            }
        }
    }

    initHomeMobileCarousel();

    var resizeTimer;
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initHomeMobileCarousel, 250);
    });

});
